import { useState } from 'react';
import { ActionInput, ActionSelect, ActionButton } from '../../../parts/index.js';
import type { CatalogueEntry, Group } from '../../access/types.js';
import type { Item } from '../contract.js';
import { NOT_GIVEN } from '../block/PermissionBlock.js';

export function ItemPicker({ effect, group, catalogue, onSave, onCancel }: {
  effect: 'give' | 'hold'; group: Group; catalogue: CatalogueEntry[]; onSave: (item: Item) => void; onCancel: () => void;
}) {
  const [key, setKey] = useState(''); const [reason, setReason] = useState('');
  const label = effect === 'give' ? 'Give one item' : 'Hold one back';
  const choices = [
    ...catalogue.flatMap(f => {
      const cell = group.features.find(c => c.key === f.key);
      if (!cell || cell.enabled !== (effect === 'hold') || NOT_GIVEN.includes(f.key)) return [];
      return [{ key: `feature:${f.key}`, name: f.name, why: cell.locked ? cell.why : null, item: { kind: 'feature' as const, featureKey: f.key, reason } }];
    }),
    ...group.reading.filter(c => (c.access !== 'none') === (effect === 'hold')).map(c => ({
      key: `subject:${c.domainTier}`, name: c.name, why: effect === 'give' && c.locked ? c.why : null,
      item: { kind: 'subject' as const, domainTier: c.domainTier, reason },
    })),
  ];
  const selected = choices.find(c => c.key === key);
  return <fieldset className="confirm"><legend>{label}</legend>
    <label className="fieldrow">{label}<ActionSelect className="field" value={key} onChange={e => setKey(e.target.value)}>
      <option value="">choose…</option>{choices.map(c => <option key={c.key} value={c.key} disabled={!!c.why}>{c.name}</option>)}
    </ActionSelect></label>
    {choices.filter(c => c.why).map(c => <p key={c.key}>{c.name}: {c.why}</p>)}
    <label className="fieldrow">Reason, required<ActionInput className="field" value={reason} required onChange={e => setReason(e.target.value)} /></label>
    <div className="opts"><ActionButton className="opt" disabled={!selected || !!selected.why || !reason.trim()} onClick={() => { if (selected && !selected.why && reason.trim()) onSave({ ...selected.item, reason: reason.trim() }); }}>{label}</ActionButton>
      <ActionButton className="opt" onClick={onCancel}>Cancel</ActionButton></div>
    {!reason.trim() && <p>Give a reason first</p>}
  </fieldset>;
}
